var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-connection",class:{hide: _vm.hideWindow}},[_c('div',{staticClass:"upper"},[_c('i',{staticClass:"material-icons"},[_vm._v("wifi_off")]),_c('span',[_vm._v(_vm._s(_vm.tokens.noConnectionModal.connectionLost))])]),_c('button',{on:{"click":_vm.refresh}},[_vm._v(_vm._s(_vm.tokens.noConnectionModal.retryNow))])])
}
var staticRenderFns = []

export { render, staticRenderFns }